export const env =
  window.location.host === 'stg-mozartdata.uc.r.appspot.com' ? 'staging' : process.env.NODE_ENV;
